module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/183.57ec654a.png";